import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { IOrderDisassociateUnitModel } from '@apps-common/types/management/order'

export const disassociateUnitOrder = async (model: IOrderDisassociateUnitModel): Promise<boolean> =>
  axios.post(`/management/order/DisassociateUnitsOrder`, model).then((res) => res?.data?.data)

type Props = {
  model: IOrderDisassociateUnitModel
}

export const useManagementDisassociateUnitOrder = (notify?: boolean, onSuccess?: (data: boolean) => void) =>
  useMutation({
    mutationKey: ['associateUnitOrder'],
    mutationFn: ({ model }: Props) => disassociateUnitOrder(model),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Updated order.')
      }
    },
    onError: (e) => {
      if (notify) {
        toastError(e?.message || 'Failed to update order.')
      }
    },
    throwOnError: false
  })
